import React from 'react';
import './IntroCurtain.css';

export default function IntroCurtain() {
  return (
    <div className="intro-curtain" aria-hidden="true">
      <div className="intro-curtain-mark">
        <svg width="86" height="67" viewBox="0 0 72 56" fill="none">
          <path className="intro-curtain-r" d="M14 46 V24 Q14 14 24 14 H28" stroke="#0A0A0C" strokeWidth="9" strokeLinecap="round" />
          <path className="intro-curtain-chev1" d="M36 17 L49 30 L36 43" stroke="#E5382B" strokeWidth="9" strokeLinecap="round" strokeLinejoin="round" />
          <path className="intro-curtain-chev2" d="M50 17 L63 30 L50 43" stroke="#E5382B" strokeWidth="9" strokeLinecap="round" strokeLinejoin="round" opacity="0.55" />
        </svg>
        <div className="intro-curtain-word">roon<span>bash</span></div>
      </div>
    </div>
  );
}
